<template>
	<BasicDialog :rounded="'rounded-24'">
		<div class="payout-withdrawl-dialog d-flex flex-column align-center ga-3">
			
			
			<img :src="AppConfigs.staticImages.PAYOUTWITHDRAWLSUCCESSFULL" class="payout-withdrawl-dialog__image" />
			
			<span class="text-h5 font-weight-bold text-center">Request Submitted!</span>
			
			<span class="text-body-2 text-center">Your gift card redeem request has been submitted.</span>
			
			<v-btn rounded="pill" @click="redirectToRewards"
				class="button--primary px-16 py-6 d-flex text-none">
				<span>Got it</span>
			</v-btn>



		</div>
	</BasicDialog>
</template>



<script setup lang="ts">

import { useRouter } from 'vue-router';
import { AppConfigs } from "@/app.configs";
import { PayoutStore } from "@/store/PayoutStore";
import { computed, watch, ref, provide } from "vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

const router = useRouter();
const openDialog = ref(false);
provide("openDialog", openDialog);

const payoutStore = PayoutStore();
const payoutData = computed(() => payoutStore.SuccessResponsePayoutData);

watch(payoutData, () => {
	openDialog.value = true;
});

const redirectToRewards = () => {
	openDialog.value = false;
	router.push('/rewards');
};

</script>